var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptySequences(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1054 233",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".549%",
    y1: "37.443%",
    x2: "99.448%",
    y2: "56.791%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E98F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDCCA2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.784%",
    y1: "49.86%",
    x2: "99.78%",
    y2: "49.86%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDCCA2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCBA3",
    offset: "44.45%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4C7A7",
    offset: "60.46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C1AD",
    offset: "71.87%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B6",
    offset: "81.11%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2ADC2",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879FD0",
    offset: "95.88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7394DB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".39%",
    y1: "37.671%",
    x2: "99.29%",
    y2: "57.018%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E98F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDCCA2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.8%",
    y1: "49.86%",
    x2: "99.764%",
    y2: "49.86%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDCCA2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCBA3",
    offset: "44.45%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4C7A7",
    offset: "60.46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C1AD",
    offset: "71.87%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B6",
    offset: "81.11%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2ADC2",
    offset: "89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879FD0",
    offset: "95.88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7394DB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".299%",
    y1: "43.942%",
    x2: "99.599%",
    y2: "55.752%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68659",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D89868",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.007%",
    y1: "50.01%",
    x2: "100.029%",
    y2: "50.01%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1DEF5",
    offset: "78.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D8F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.045%",
    y1: "50.099%",
    x2: "99.955%",
    y2: "50.099%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1DEF5",
    offset: "78.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D8F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".045%",
    y1: "50.099%",
    x2: "100.045%",
    y2: "50.099%",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1DEF5",
    offset: "78.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D8F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".101%",
    y1: "50.113%",
    x2: "100.07%",
    y2: "50.113%",
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1DEF5",
    offset: "78.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D8F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.113%",
    x2: "99.969%",
    y2: "50.113%",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1DEF5",
    offset: "78.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D8F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.054%",
    y1: "100.116%",
    x2: "50.054%",
    y2: ".091%",
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFE",
    offset: "50.26%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F6FA",
    offset: "80.94%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEEF6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1.599%",
    y1: "49.163%",
    x2: "101.927%",
    y2: "49.163%",
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F5FC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E3F7",
    offset: "65.78%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D8F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.121%",
    y1: "49.96%",
    x2: "102.244%",
    y2: "49.96%",
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F5FC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E3F7",
    offset: "65.78%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D8F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.006%",
    y1: "99.944%",
    x2: "50.006%",
    y2: ".026%",
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0C19F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4C5A0",
    offset: "7.861%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCAA2",
    offset: "32.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDCCA2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.975%",
    y1: "99.936%",
    x2: "49.975%",
    y2: "-.011%",
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDCCA2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A297",
    offset: "68.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#908D92",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.486%",
    y1: "100.217%",
    x2: "49.486%",
    y2: "-.029%",
    id: "p"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#639EF7",
    offset: "53.46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#629DF5",
    offset: "73.92%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F98EE",
    offset: "81.29%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A90E3",
    offset: "86.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5384D2",
    offset: "90.79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4975BC",
    offset: "94.43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D63A1",
    offset: "97.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.942%",
    y1: "99.449%",
    x2: "47.942%",
    y2: "-.45%",
    id: "q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#639EF7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#629CF5",
    offset: "35.27%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F97ED",
    offset: "52.38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#598EE0",
    offset: "65.59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5182CE",
    offset: "76.79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4671B6",
    offset: "86.73%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A5D98",
    offset: "95.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.108%",
    y1: "101.664%",
    x2: "49.108%",
    y2: "-.162%",
    id: "r"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#639EF7",
    offset: "39.96%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#629DF5",
    offset: "66.36%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F98EE",
    offset: "75.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A90E3",
    offset: "82.64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5384D2",
    offset: "88.12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4975BC",
    offset: "92.81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D63A1",
    offset: "96.89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.163%",
    y1: "49.525%",
    x2: "100.024%",
    y2: "49.525%",
    id: "s"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D63A1",
    offset: "3.106%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4975BC",
    offset: "7.188%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5384D2",
    offset: "11.88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A90E3",
    offset: "17.36%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F98EE",
    offset: "24.14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#629DF5",
    offset: "33.64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#639EF7",
    offset: "60.04%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.838%",
    y1: "48.549%",
    x2: "99.349%",
    y2: "48.549%",
    id: "t"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D63A1",
    offset: "3.106%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4975BC",
    offset: "7.188%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5384D2",
    offset: "11.88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A90E3",
    offset: "17.36%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F98EE",
    offset: "24.14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#629DF5",
    offset: "33.64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#639EF7",
    offset: "60.04%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.371%",
    y1: "49.139%",
    x2: ".607%",
    y2: "49.139%",
    id: "u"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325187",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D63A1",
    offset: "3.106%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4975BC",
    offset: "7.188%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5384D2",
    offset: "11.88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A90E3",
    offset: "17.36%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F98EE",
    offset: "24.14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#629DF5",
    offset: "33.64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#639EF7",
    offset: "60.04%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.662%",
    y1: "87.715%",
    x2: "101.012%",
    y2: "31.152%",
    id: "x"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68659",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8885B",
    offset: "31.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8F60",
    offset: "43.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D89868",
    offset: "50.06%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68659",
    offset: "96.77%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.426%",
    y1: "-10.116%",
    x2: "14.027%",
    y2: "97.236%",
    id: "y"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68659",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8885B",
    offset: "31.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8F60",
    offset: "43.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D89868",
    offset: "50.06%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68659",
    offset: "96.77%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.668%",
    y1: "71.073%",
    x2: "53.644%",
    y2: "33.703%",
    id: "z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D89868",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68659",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "93.455%",
    y1: "6.145%",
    x2: "47.024%",
    y2: "53.15%",
    id: "A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "v",
    d: "M.994.442h74.3v51.6H.994z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(289 77)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D3257",
    d: "M15.6 16.2v-4.1l3.4-.6v5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9 11l-2-8 1.6 1.2-11.4-.5V1.2L21.5.8c.7 0 1.4.4 1.6 1.1V2l2.6 7.8-3.8 1.2zM25.7 17.4l-2.6 7.8v.1c-.2.7-.9 1.1-1.6 1.1l-11.4-.5v-2.5l11.4-.4-1.6 1.2 2-8 3.8 1.2z",
    fill: "#0F3567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7 8.8c3.1-.2 6.1-.1 9.2.2 7.4.8 12.6 2.8 12.6 5.2 0 2.4-5.3 4.4-12.6 5.2-3 .3-6.1.4-9.2.2l-17.7-1V9.8l17.7-1z",
    fill: "#EAEEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10c-3.9 0-7.3 1.6-9.3 4.1 2 2.5 5.4 4.1 9.3 4.2h.1c6.4-.1 6.4-8.2 0-8.3h-.1z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7 12.7c-1.4 0-2.6.6-3.3 1.5.7.9 1.9 1.5 3.3 1.5 2.3-.1 2.3-3 0-3 .1 0 0 0 0 0z",
    fill: "#DDCCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5 14.1c0-1.8-2.9-3.3-7.4-4.3-.4 1.3-.6 2.8-.6 4.3s.2 3 .6 4.3c4.5-.9 7.4-2.5 7.4-4.3z",
    fill: "#1D3257"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#1D3257",
    fill: "#6E98F0",
    cx: 43,
    cy: 14.1,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6E98F0",
    cx: 36,
    cy: 14.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6E98F0",
    cx: 31.7,
    cy: 14.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6E98F0",
    cx: 27.4,
    cy: 14.1,
    r: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.5 14l70.3-2c1.1 0 2 .8 2.1 1.9 0 1.1-.8 2-1.9 2.1h-.1L.5 14z",
    fill: "url(#b)",
    transform: "translate(211 77)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M221.8 57l18.7-4.3c17.4-4 35 5.5 41.3 22.2M417.1 113l-9.6 3c-18.4 5.8-38.5 1.5-52.9-11.4",
    stroke: "#BCCADE",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeDasharray: "0,12"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(720 77)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D3257",
    d: "M16 16.2v-4.1l3.4-.6v5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3 11l-2-8 1.6 1.2-11.4-.5V1.2L21.9.8c.7 0 1.4.4 1.6 1.1V2l2.6 7.8-3.8 1.2zM26.1 17.4l-2.6 7.8v.1c-.2.7-.9 1.1-1.6 1.1l-11.4-.5v-2.5l11.4-.4-1.6 1.2 2-8 3.8 1.2z",
    fill: "#0F3567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1 8.8c3.1-.2 6.1-.1 9.2.2 7.4.8 12.6 2.8 12.6 5.2 0 2.4-5.3 4.4-12.6 5.2-3 .3-6.1.4-9.2.2l-17.7-1V9.8l17.7-1z",
    fill: "#EAEEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9 10C6 10 2.6 11.6.6 14.1c2 2.5 5.4 4.1 9.3 4.2h.1c6.4-.1 6.4-8.2 0-8.3h-.1z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1 12.7c-1.4 0-2.6.6-3.3 1.5.7.9 1.9 1.5 3.3 1.5 2.3-.1 2.3-3 0-3z",
    fill: "#DDCCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9 14.1c0-1.8-2.9-3.3-7.4-4.3-.4 1.3-.6 2.8-.6 4.3s.2 3 .6 4.3c4.5-.9 7.4-2.5 7.4-4.3z",
    fill: "#1D3257"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#1D3257",
    fill: "#6E98F0",
    cx: 43.4,
    cy: 14.1,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6E98F0",
    cx: 36.4,
    cy: 14.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6E98F0",
    cx: 32.1,
    cy: 14.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6E98F0",
    cx: 27.8,
    cy: 14.1,
    r: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.9 14l70.3-2c1.1 0 2 .8 2.1 1.9 0 1.1-.8 2-1.9 2.1h-.1L.9 14z",
    fill: "url(#d)",
    transform: "translate(642 77)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M831.9 55.8l-18.7-4.3c-17.4-4-35 5.5-41.3 22.2M646.8 117.5l9.6 3c18.4 5.8 38.5 1.5 52.9-11.4",
    stroke: "#BCCADE",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeDasharray: "0,12"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(427 21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2 150.8h111.3l.4-2.2c.2-1.1.3-2.2.3-3.3-.9-30.4-25.9-54.8-56.6-54.8-30.4 0-55.2 24-56.5 54-.1 1.6.2 3.3.7 4.8l.4 1.5z",
    fill: "#EAEEF6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#325187",
    d: "M1.4 1.3h37.2v32.4H1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6 2.3v30.4H2.4V2.3h35.2zm2-2H.4v34.4h39.2V.3z",
    fill: "#EAEEF6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.4 11.8h39.2M.4 23.3h39.2M13.4 34.7V.3M26.5 34.7V.3",
    stroke: "#389EF9",
    strokeWidth: 2,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6 18.7l3.5 2.5c3.9 2.8 9.2 2.7 13-.3l5-4c4.7-3.7 11.5-2.9 15.2 1.8",
    stroke: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 12.4,
    cy: 11.9,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 28.4,
    cy: 7.4,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 27.1,
    cy: 25.1,
    r: 1.8
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#325187",
    d: "M19.8 41.3h36.4v32.4H19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1 42.3v30.4H20.7V42.3h34.4zm2-2H18.7v34.4h38.4V40.3z",
    fill: "#EAEEF6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22 45)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#C0CADD",
    transform: "rotate(-59.584 22.654 5.682)",
    cx: 22.654,
    cy: 5.682,
    rx: 5.1,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#C0CADD",
    opacity: 0.5,
    transform: "rotate(-59.999 22.625 5.692)",
    cx: 22.625,
    cy: 5.692,
    rx: 1,
    ry: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M10.535 8.47l1.556-1.556 1.555 1.556-1.555 1.555z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 18.1c-1 .4-1.9 1.4-2.3 2.3-.1.2-.4.2-.5 0-.4-1-1.4-1.9-2.3-2.3-.2-.1-.2-.4 0-.5 1-.4 1.9-1.4 2.3-2.3.1-.2.4-.2.5 0 .4 1 1.4 1.9 2.3 2.3.3 0 .3.4 0 .5z",
    fill: "#649EF7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#649EF7",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 .8v3.1M6.5 2.3H3.4"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAEEF6",
    d: "M120.7 94.7h64.9V112h-64.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#649EF7",
    d: "M135.835 107.552h-9.5v-8.3h9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#325187",
    d: "M181.245 107.552h-9.5v-8.3h9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#649EF7",
    opacity: 0.2,
    d: "M166.35 103.385h-4.8v-4.2h4.8zM157.872 106.927h-4.8v-4.2h4.8z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#325187",
    d: "M67.5 1.6h117.1v85.5H67.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.1 3.1v82.5H69V3.1h114.1zm3-3H66v88.5h120.1V.1z",
    fill: "#EAEEF6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    stroke: "#389EF9",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.7 4.1h114.4M68.7 85.1h114.4M68.7 64.8h114.4M68.7 44.6h114.4M68.7 24.4h114.4"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    stroke: "#389EF9",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4 85.6V3.2M166.4 85.6V3.2M146.1 85.6V3.2M125.9 85.6V3.2M105.7 85.6V3.2"
  })), /*#__PURE__*/React.createElement("circle", {
    stroke: "#6DFEFF",
    cx: 76.6,
    cy: 36.3,
    r: 2
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFEFD",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102 75.6v4.9M104.4 78.1h-4.8"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFEFD",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.7 13.1v4M176.7 15.1h-4"
  })), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFFEFD",
    strokeLinecap: "round",
    cx: 95.3,
    cy: 14.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7394DB",
    fillRule: "nonzero",
    d: "M170.942 75.058l3.077-2.859 2.86 3.077-3.077 2.859z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M111.8 28.8h38v27h-38z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BCCADE",
    strokeWidth: 2,
    opacity: 0.65,
    d: "M147.9 30.8l-17.1 17-17.1-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.4 75.6c17.894 0 32.4-14.506 32.4-32.4s-14.506-32.4-32.4-32.4S98 25.306 98 43.2s14.506 32.4 32.4 32.4z",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5.9857,5.9857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4 113.6l12.5 11.2c10.7 9.6 27.9 9.8 38.8.4",
    stroke: "#EAEEF6",
    strokeWidth: 19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.1 103.4l3.1 6.2c.8 1.6-.2 3.5-1.9 3.9-1.7.4-3.4-1-3.3-2.8l.4-6.9c0-.9 1.3-1.2 1.7-.4z",
    fill: "#325185",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#e)",
    fillRule: "nonzero",
    cx: 147.7,
    cy: 119.3,
    r: 11.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#D69668",
    fillRule: "nonzero",
    transform: "rotate(-32.047 149.09 118.042)",
    cx: 149.089,
    cy: 118.042,
    rx: 9.6,
    ry: 11
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BCCADE",
    fillRule: "nonzero",
    opacity: 0.5,
    d: "M81.6 125.5l-21-21h21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCCADE",
    fillRule: "nonzero",
    opacity: 0.5,
    d: "M46.2 125.5l21-21h-21z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31 56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2 32.9C2.6 19.1 11 6 24.2 1.6c6-2 12.5-2 18.5 0 12.7 4.2 21 16.5 20.1 29.8l-.1 1.5c-.9 14.7-13.2 26.2-27.9 26.2H32C17.4 59 5.2 47.6 4.2 32.9z",
    fill: "#D69668",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4 42h-8.5c-5.7 0-10.3-4.6-10.3-10.3 0-5.7 4.6-10.3 10.3-10.3h8.5c5.7 0 10.3 4.6 10.3 10.3 0 5.7-4.6 10.3-10.3 10.3z",
    fill: "#DBCAA0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 30.4h-4.2c-2 0-3.6-1.6-3.6-3.6s1.6-3.6 3.6-3.6h4.2c2 0 3.6 1.6 3.6 3.6s-1.7 3.6-3.6 3.6z",
    fill: "#243865",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#243865",
    fillRule: "nonzero",
    cx: 46,
    cy: 18.2,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#243865",
    fillRule: "nonzero",
    cx: 21.9,
    cy: 18.2,
    r: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8 30.2l-1 3.5c-.1.3-.4.4-.6.4-.2-.1-.3-.2-.4-.4l-1-3.5c-.2-.8.2-1.7 1.1-1.9.8-.2 1.7.2 1.9 1.1.1.2.1.5 0 .8z",
    fill: "#243865",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 37.5l1.8.3c2 .3 3.8-1 4.2-3",
    stroke: "#243865",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D69668",
    fillRule: "nonzero",
    cx: 60.4,
    cy: 8.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2 8.6c1.3 2.4-10.1-.2-7.3-1.7 2.8-1.4 6-.7 7.3 1.7z",
    fill: "#DBCAA0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D69668",
    fillRule: "nonzero",
    cx: 7,
    cy: 8.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2 8.4c-1.3 2.4 10.1-.2 7.3-1.7C7.7 5.3 4.4 6 3.2 8.4z",
    fill: "#DBCAA0",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#639EF7",
    fillRule: "nonzero",
    d: "M58.1 113.8h9.7v7.4h-9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639EF7",
    fillRule: "nonzero",
    d: "M66.2 121.1h-6.6l-2.3 30.7 5.6 6.2 5.7-6.2z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D69668",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.9 59.5l-1.8-8.8.2-.9c-2.1 1.1-2.9 3.9-4.4 5.6-1.5 1.8-3.1 3.4-3.8 5.6 0 .1.5.3.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8 61.8c-.9-4.4.4-4.7-.5-9l-.7.3c-2.1 1.1-3.8 2.6-5.3 4.4-1.5 1.8-3.1 3.6-3.9 5.8 0 .1.5.3.5.4"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M16.6 197.6h239.5v56H16.6z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#243e6d",
    fontFamily: "soleil, sans-serif",
    fontSize: 14
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(36.288 193.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 14,
    y: 14
  }, "Sequences send a series of")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(36.288 193.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 36
  }, "personalized emails to a contact"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M429.2 197.6h182v56h-182z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#243e6d",
    fontFamily: "soleil, sans-serif",
    fontSize: 14
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(435.41 193.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "Emails are tracked for any")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(435.41 193.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 22.2,
    y: 36
  }, "opens or link clicks")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M823.7 197.6h206.7v56H823.7z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#243e6d",
    fontFamily: "soleil, sans-serif",
    fontSize: 14
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(831.598 193.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 17,
    y: 14
  }, "Once there is a reply the")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(831.598 193.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.8,
    y: 36
  }, "sequence automatically stops")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFEFD",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.7 82.2v6.7M195 85.6h-6.7"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M146.7.2L227 80.5H66.3z",
    transform: "translate(0 91)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M210.6 32.7l47.8 47.8h-95.6z",
    transform: "translate(0 91)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M70.6 32.7l47.8 47.8H22.8z",
    transform: "translate(0 91)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M249.9 57.7l22.8 22.8H227z",
    transform: "translate(0 91)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M22.8 57.7l22.9 22.8H0z",
    transform: "translate(0 91)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(116 42)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C9D8F4",
    fillRule: "nonzero",
    d: "M32 117.3h-8.8l-1.3-7.2h11.4z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0F3567",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 103.7L5 108l2.4-3.2-.9 25.1H1.6l-.9-25.1c-.1-1.5.9-2.7 2.2-3.2l.2-.1L19.7 96l2.3 7.7zM35.5 96l16.6 5.5.2.1c1.4.5 2.2 1.8 2.2 3.2l-.9 25.1h-4.9l-.9-25.1 2.4 3.2-16.9-4.3 2.2-7.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.2 128.8c0 6.9 2.9 13 7.4 16.5 4.5-3.6 7.4-9.6 7.4-16.5v-.2c-.1-11.4-14.7-11.4-14.8 0v.2z",
    fill: "#6E98F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9 126.7c0 3.4 1.5 6.5 3.7 8.3 2.2-1.8 3.7-4.8 3.7-8.3v-.1c0-5.7-7.3-5.7-7.4 0v.1z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F3567",
    fillRule: "nonzero",
    d: "M17.8 38h19.6v25.5H17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3 1.3l-2 5.6h6.5l-2-5.6c-.3-1.2-2.1-1.2-2.5 0z",
    fill: "#6E98F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9D8F4",
    fillRule: "nonzero",
    d: "M24.3 6.9h6.5v5.9h-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEEF6",
    fillRule: "nonzero",
    d: "M30.9 12.8h-6.6L17.8 38h19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    fillRule: "nonzero",
    d: "M17.8 63.5h19.6v46.7H17.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6E98F0",
    fillRule: "nonzero",
    cx: 27.6,
    cy: 50.8,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6E98F0",
    fillRule: "nonzero",
    cx: 27.6,
    cy: 74.1,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6E98F0",
    fillRule: "nonzero",
    cx: 27.6,
    cy: 87.5,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#325187",
    fillRule: "nonzero",
    d: "M25.384 112.137v-14h4.5v14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6 25v7.3",
    stroke: "#BBC9DE",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2 25v7.3M22 25v7.3",
    stroke: "#C9D8F4",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#BBC9DE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.6 70.3v101.5M82.8 171.8V70.3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    strokeLinejoin: "round",
    d: "M100.6 156.1H82.8l17.8-18.3H82.8l17.8-18.2H82.8l17.8-18.2"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    strokeLinejoin: "round",
    d: "M82.8 83.2h17.8l-17.8 18.2H120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.8 108.5v63.3M183 171.8v-56.7",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    strokeLinejoin: "round",
    d: "M201.2 156.1H183l17.8-18.3H183l17.8-18.2H183M222.8 137.8H183"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211 43.8c-.3-2-2.1-3.5-4.2-3.5-1.3 0-2.4.6-3.2 1.5-1.1-3.1-4.1-5.3-7.6-5.3-2.7 0-5.1 1.3-6.5 3.3-1.1-1-2.6-1.6-4.2-1.6-3.3 0-6 2.5-6.3 5.6h32z",
    stroke: "url(#l)",
    transform: "translate(0 6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8 102.4c-2.2-5.7-7.7-9.8-14.1-9.8-3.6 0-7 1.3-9.6 3.4-3.9-6-10.7-10-18.4-10-10.2 0-18.7 7-21.1 16.4h63.2z",
    stroke: "url(#m)",
    strokeWidth: 2,
    transform: "translate(0 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDCCA2",
    fillRule: "nonzero",
    d: "M171.974 69.867l2.828-2.829 2.828 2.829-2.828 2.828zM91.665 34.426l2.829-2.829 2.828 2.829-2.828 2.828z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#DDCCA2",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.4 6.7v5.6M156.2 9.5h-5.6"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(803 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    strokeWidth: 2,
    cx: 66.4,
    cy: 23.2,
    r: 3
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFEFD",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.4 50.3v8M129.4 54.3h-8"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DDCCA2",
    fillRule: "nonzero",
    d: "M215.886 32.837l4.176-3.88 3.88 4.174-4.175 3.881z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    fillRule: "nonzero",
    d: "M.4 118.6l14.7-12.4 9-12 6.6 1 44.6-44.8 43.2 39.3L132.6 78l21-27.1 16.7-30.6 32.8 18.8 15.3 36.3 7.8 6.2 21.6 37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    fillRule: "nonzero",
    opacity: 0.25,
    d: "M193.4 39.8l3.3 19.9 12.3 41.4 8.7 17h9.7L220.7 84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4 170.5h-63.5c6.2-3.9 10-10.8 10-18.2v-37.6c0-12 9.7-21.7 21.7-21.7s21.7 9.7 21.7 21.7v37.6c.1 7.4 3.9 14.3 10.1 18.2z",
    fill: "#639EF7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125 46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.6 28.6l-.2 9.4v.7c0 .3 0 .6-.1.8-.1.6-.3 1.1-.5 1.6-.4 1-1.1 1.9-2 2.7-.8.7-1.8 1.3-2.9 1.5-.5.1-1.1.2-1.6.2h-1c-1 .1-1.8.7-2.4 1.6-.2.4-.4.9-.4 1.4v2.3l-.2 9.4h-3.1l-.2-9.4V49v-.7c0-1.1.3-2.1.8-3.1 1-1.9 2.9-3.3 5-3.7.3 0 .5-.1.8-.1H71.2c.2 0 .5-.1.7-.1.4-.1.9-.4 1.2-.7.3-.3.6-.7.7-1.1.1-.2.1-.4.1-.7V38l-.2-9.4h4.9z",
    fill: "url(#p)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#639EF7",
    fillRule: "nonzero",
    cx: 77.5,
    cy: 20.8,
    r: 9.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 77.5,
    cy: 20.8,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#325187",
    fillRule: "nonzero",
    cx: 46.7,
    cy: 91,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#325187",
    fillRule: "nonzero",
    cx: 68.9,
    cy: 105.5,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#325187",
    fillRule: "nonzero",
    cx: 67.4,
    cy: 60.8,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#325187",
    fillRule: "nonzero",
    cx: 72.7,
    cy: 65.7,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#325187",
    fillRule: "nonzero",
    cx: 76.4,
    cy: 20.7,
    r: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 50.7l-.2-9.8v-.6-.3c0-.2-.1-.4-.2-.5-.2-.3-.5-.5-.9-.6h-.8c-.6 0-1.3-.2-1.9-.4-1.2-.5-2.2-1.5-2.7-2.6-.3-.6-.4-1.2-.5-1.9V32.7l-.1-2.4-.1-4.9-.2-9.8h5l-.2 9.8-.1 4.9-.1 2.4v1.1c0 .2 0 .3.1.5.1.3.4.6.7.7.2.1.3.1.5.2 0 0 .4 0 .7.1.3 0 .6.1.9.2 1.2.4 2.3 1.2 2.9 2.3.3.5.5 1.1.7 1.8.1.3.1.6.1.9v.6l-.2 9.8H55v-.2z",
    fill: "url(#q)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#639EF7",
    fillRule: "nonzero",
    cx: 49.7,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 49.7,
    cy: 12,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#325187",
    fillRule: "nonzero",
    cx: 47.7,
    cy: 11.9,
    r: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4 35.8l-.1 5.1v1.8c0 .1 0 .2.1.3.1.4.4.7.7 1l.6.3h.7c.2 0 .3 0 .5.1 1.2.2 2.4.9 3.2 1.8.8 1 1.2 2.2 1.2 3.4v4.3c0 .1 0 .2.1.3.1.5.4.9.8 1.2.2.1.4.2.7.3.2.1.4.1.9.1h2.5l10.2.2v2.5l-10.2.2h-2.5c-.3 0-1 0-1.6-.1-.6-.1-1.2-.4-1.7-.7-1-.6-1.8-1.7-2.2-2.8-.1-.3-.1-.6-.2-.9v-4.6c0-.5-.2-.9-.5-1.2-.3-.3-.7-.5-1.1-.6h-.4c-.3 0-.6 0-.9-.1-.6-.1-1.2-.3-1.8-.7-1.1-.7-2-1.7-2.4-2.9-.1-.3-.2-.6-.2-.9V41l-.1-5.1h3.7v-.1z",
    fill: "url(#r)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9 82.8l-9.1-.4h-.6l-.7-.1c-.5 0-.9-.1-1.4-.2-.9-.2-1.8-.6-2.6-1-1.6-.9-3-2.2-3.8-3.8-.9-1.6-1.4-3.4-1.3-5.1v-1c0-.3 0-.6-.1-.9-.1-.6-.3-1.2-.6-1.8-1.1-2.3-3.6-4-6.3-4.2v-1.7c3.3-.2 6.8 1.6 8.5 4.6.4.8.8 1.5 1 2.4.1.4.2.9.3 1.3l.1 1.2c.1 1.3.5 2.4 1.2 3.4s1.7 1.8 2.7 2.3c.5.2 1.1.4 1.7.5.3 0 .6.1.9.1h.9l9.1-.4v4.8h.1z",
    fill: "url(#s)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#639EF7",
    fillRule: "nonzero",
    cx: 27.4,
    cy: 29.8,
    r: 9.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 27.4,
    cy: 29.8,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#325187",
    fillRule: "nonzero",
    cx: 25.5,
    cy: 29.6,
    r: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 96.1l-2.4-.1-1.2-.1h-.5c-.3.1-.7.3-.8.7-.1.2-.1.3-.2.6 0 .6-.2 1.2-.4 1.8-.5 1.1-1.5 2-2.6 2.4-.5.2-1.2.3-1.7.3l-1.2-.1-4.9-.5v-1.3l4.9-.5 1.2-.1c.3 0 .5-.1.7-.2.4-.2.7-.6.8-.9.1-.2.1-.4.1-.6 0-.6.1-1.2.3-1.8.4-1.2 1.4-2.2 2.5-2.7.6-.3 1.2-.4 1.9-.4l1.2-.1 2.4-.1v3.7h-.1z",
    fill: "url(#t)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#639EF7",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 100.5c0 2.3-1.9 4.2-4.2 4.2-1.5 0-2.8-.8-3.5-1.9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 100.1c0-2.3-1.9-4.2-4.2-4.2-1.5 0-2.8.8-3.5 1.9",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#639EF7",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 63.8c-2.5 2.5-6.6 2.5-9.1 0-1.6-1.6-2.2-3.9-1.7-6M11.9 63.4c2.5-2.5 2.5-6.6 0-9.1-1.6-1.6-3.9-2.2-6-1.7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.7 90.5l5.3.4h.9c.3 0 .5-.1.8-.2.5-.2 1-.5 1.4-1 .4-.5.6-1 .7-1.7v-.3l.1-.4c.1-.3.1-.6.2-.8.2-.5.4-1.1.7-1.5 1.2-1.9 3.4-3 5.5-2.8v1.7c-1.5.1-2.8 1.1-3.3 2.4-.1.3-.2.6-.3 1v1c0 1.1-.2 2.3-.8 3.4-.6 1-1.4 1.9-2.5 2.6-.5.3-1.1.6-1.7.7-.3.1-.6.1-.9.2h-.9l-5.3.4v-5.1h.1z",
    fill: "url(#u)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3 82.2c.3.4.7.7 1.3.9.5.2 1.1.1 1.7-.1.6-.2 1.1-.6 1.4-1.2.4-.6.5-1.3.4-2 0-.3.2-.5.5-.6.2 0 .5.1.5.4.3.9.3 1.9-.1 2.8-.3.9-1 1.8-1.8 2.3-.9.6-1.9.9-3 .8-1.1-.1-2.2-.5-3-1.3l-.1-.1c-.6-.5-.7-1.5-.2-2.1.5-.6 1.5-.7 2.1-.2.2.2.3.3.3.4z",
    fill: "#639EF7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 83c-1.5-1.5-1.5-3.9 0-5.4 1-1 2.3-1.3 3.5-1",
    stroke: "#639EF7",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6 63.8c0 4-3.3 7.3-7.3 7.3h-5.7",
    stroke: "#0F3567",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BCCADE",
    fillRule: "nonzero",
    opacity: 0.5,
    d: "M116.1 134l-83.9-5v5l15.4 18.4h83.9v-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEEF6",
    fillRule: "nonzero",
    d: "M116.1 129H32.2l15.4 18.4h83.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M49.8 142.8L38.4 129h71.9l11.3 13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 132.6H41.1M117.8 138.2H46M86.3 129l11.3 13.8M98.2 129l11.4 13.8M74.3 129l11.4 13.8M62.3 129l11.4 13.8M50.4 129l11.4 13.8",
    stroke: "#649EF7",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEEF6",
    fillRule: "nonzero",
    d: "M32.2 65.4h83.9V129H32.2z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36 71)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "w",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#325187",
    fillRule: "nonzero",
    transform: "rotate(-180 38.144 26.242)",
    xlinkHref: "#v"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#w)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#243865",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6 14.1l.7 2.9c.2.7 1 1.1 1.7.8.7-.4.8-1.3.3-1.8l-2-2.2c-.3-.3-.8-.1-.7.3zM61.3 12.1l-1 1.8c-.2.5 0 1 .5 1.1.5.1 1-.3 1-.8v-2c0-.3-.4-.4-.5-.1zM64 13.4l-1.4 1.5c-.4.4-.3 1 .2 1.2.5.2 1 0 1.1-.5l.5-2c.1-.2-.2-.4-.4-.2zM66 15.6l-1.6 1.2c-.4.3-.4.9 0 1.3.4.3 1 .2 1.2-.3l.8-1.8c.1-.3-.2-.6-.4-.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 39H0c.4 1.2 1.2 2.3 2.3 3",
    fill: "#D19161",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1 37.4l-1.6-.2c.2.9.6 1.6 1.3 2.2",
    fill: "#D19161",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4 61.4h-6.8c-7.1 0-12.9-5.8-12.9-12.9V24.4c0-3 2.4-5.4 5.4-5.4h14.3c8.3 0 15 6.7 15 15v12.5c0 8.2-6.7 14.9-15 14.9z",
    fill: "#DBE1EE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#649EF7",
    fillRule: "nonzero",
    opacity: 0.2,
    cx: 3.3,
    cy: 28.2,
    rx: 1,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#649EF7",
    fillRule: "nonzero",
    opacity: 0.2,
    d: "M3.5 31.3h1v1h-1zM2.6 30.1h1v1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6 61.4H15c-5.3 0-9.5-4.3-9.5-9.5V25.8c0-3.7 3-6.7 6.7-6.7h28.4c3.1 0 5.6 2.5 5.6 5.6v31.2c0 3-2.6 5.5-5.6 5.5z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 20.6l7.7 2.6 1 .3c.3.1.7.2.9.3.5.1 1 .3 1.5.3.5.1 1 .1 1.5.1s1 0 1.5-.1c2-.2 3.9-1.1 5.4-2.3 1.5-1.2 2.6-2.9 3.2-4.7.8-2.4 3.4-3.6 5.7-2.8 2.4.8 3.6 3.4 2.8 5.7-.1.2-.1.3-.2.4v.1c-1.5 3.2-3.9 6-6.8 7.8-2.9 1.9-6.3 2.9-9.7 3-.8 0-1.7-.1-2.5-.1-.8-.2-1.7-.3-2.5-.5s-1.6-.5-2.4-.8c-.4-.2-.7-.3-1-.4l-.9-.4-7.4-3.4c-1.4-.6-2-2.3-1.3-3.7.7-1.2 2.2-1.9 3.5-1.4z",
    fill: "url(#x)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#649EF7",
    fillRule: "nonzero",
    opacity: 0.2,
    cx: 8.4,
    cy: 45.5,
    r: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 24.3l-6.9 4.5-1.7 1.1c-.4.3-.9.6-1.3 1-.8.7-1.5 1.5-2 2.4-1.1 1.8-1.6 3.8-1.6 5.8s.7 3.9 1.8 5.5c1.4 2 .9 4.8-1.2 6.1-2 1.4-4.8.9-6.1-1.2-.1-.1-.2-.3-.2-.4l-.1-.1C2 45.8 1.3 42.2 1.6 38.7c.3-3.5 1.6-6.9 3.7-9.6 1-1.4 2.3-2.6 3.7-3.6.7-.5 1.4-.9 2.1-1.3l1.9-1 7.4-3.8c1.4-.7 3-.2 3.7 1.2.5 1.4.1 3-1.1 3.7z",
    fill: "url(#y)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1 44c3.1 12.6-6.2 25.1-19.2 25.4h-.5c-11.4 0-18.7-9-19-20.3 0-.4 0-.8.1-1.2l1.6-15.5c1.2-7.8 7.5-13.8 15.4-14.5 9-.9 17.2 5.4 18.7 14.3L48.1 44z",
    fill: "url(#z)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1 40.1c1.2-.1 1.2 0 2.5-.1-.4-1.2-1.4-2.2-2.5-2.8l.1-.2",
    fill: "#C8885B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6 41.8l1.7.1c-.2-.9-.7-1.6-1.4-2.1",
    fill: "#CB8B5E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2 44.3c-.7-3-.4-3.1-1.2-6.1-.7-3-.9-3-1.7-6 0-.1-.1 0-.1-.1-.4-2.1-.9-4.2-2.1-5.9-1.2-1.7-3.3-2.5-5.1-3.5-1.8-.9-3.7-1.6-5.8-1.6-.4 0-.8.4-1.3.4-3 .3-5.6 1.3-7.7 3.3-2.1 2-3.3 4.4-3.8 7.4-.5 3.8-.5 3.7-.9 7.5s-.5 3.8-1.1 7.5c-.4.3-.3.9-.5 1.4l-.4-.3c.4 0 .4-.1.4.2-.5.8-.6 1.8-.6 2.7.5.3.6-.5 1.1-.4-.2.6.1.8.2 1.4.2.1.4-.2.4 0 .7 3 1.3 6.1 3.2 8.1 1.4 1.5 3.3 2.5 5.1 3.3 1.8.8 3.8.7 5.9.7.1 0 .3.4.4.4 2.5-.1 4.7-1.1 6.8-2.2 2.1-1.1 4.5-2.1 6-4.1 1.5-2 1.8-4.7 2.3-7.1.7-2.1 1.1-4.5.5-7z",
    fill: "#DDCCA2",
    fillRule: "nonzero",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 44.3h-4.7c-1.3 0-2.3-1-2.3-2.3v-3.2c0-1.3 1-2.3 2.3-2.3h4.7v7.8z",
    fill: "#DBE1EE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8 20l1.1 3.8c.4 1.3.7 2.6 1 3.9.5 2.6.8 5.3.9 8l.1 3.9v2.9c0 .1.1.3.1.4l.3.3c.1 0 .1.1.2.1s.1 0 .3.1l1.9.2 3.9.4c.5.1.9.5.8 1-.1.5-.5.9-1 .8l-3.9-.3-1.9-.1c-.1 0-.4 0-.6-.1-.2-.1-.5-.1-.7-.3-.4-.2-.8-.6-1.1-1-.3-.4-.5-.9-.5-1.4l-.1-1-.1-2-.2-3.9c-.2-2.5-.6-5-1.2-7.5-.3-1.2-.6-2.4-1-3.7l-1.2-3.7c-.3-.8.2-1.6 1-1.9.8-.2 1.7.3 1.9 1.1zM20.9 21.9c-.7 2.4-1.3 4.6-1.7 7-.4 2.4-.6 4.7-.6 7.2l-.1 3.7v2.8c0 .5-.2 1-.4 1.4-.2.4-.6.8-1 1-.4.3-.9.4-1.3.5l-1.8.3-3.6.6c-.5.1-1-.3-1.1-.8-.1-.5.2-.9.7-1.1l3.6-.8 1.8-.4c.4-.1.6-.2.7-.5.1-.1.1-.3.1-.4v-2.7l-.1-3.7c-.1-2.5.1-5.1.4-7.6.3-2.5.9-5 1.5-7.4.2-.8 1-1.3 1.8-1.1.8.3 1.3 1.1 1.1 2 0-.1 0 0 0 0z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#A)",
    fillRule: "nonzero",
    opacity: 0.15,
    cx: 18.1,
    cy: 17.3,
    r: 14.9
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#649EF7",
    cx: 17.8,
    cy: 17.3,
    r: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8 16.7c-8.6 0-15.6 3-15.6 6.7s7 6.7 15.6 6.7 15.6-3 15.6-6.7-7-6.7-15.6-6.7z",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8 5.1C8.6 5.1 2.6 3 .8.2c2.8 5.4 8.5 9.1 15.1 9.1S28.1 5.6 31 .2C29.1 3 23 5.1 15.8 5.1z",
    fill: "#5469B2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBEEF7",
    fillRule: "nonzero",
    cx: 21.1,
    cy: 6.6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBEEF7",
    fillRule: "nonzero",
    cx: 12.9,
    cy: 6.6,
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#EBEEF7",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4 6.6V7M15.6 6.2v1.2M16.8 5.8v2M17.9 6.2v1.2M19.1 6.6V7"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.8 14.8C1.2 9.6 4.3 4.7 9.3 3.1c2.3-.7 4.7-.7 7 0 4.8 1.6 7.9 6.2 7.6 11.2v.5c-.4 5.5-4.9 9.8-10.5 9.8h-1c-5.7 0-10.3-4.3-10.6-9.8z",
    fill: "#D89868",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17.4h-4.1c-1.9 0-3.4-1.5-3.4-3.4v-.9c0-1.9 1.5-3.4 3.4-3.4H16c1.9 0 3.4 1.5 3.4 3.4v.9c.1 1.9-1.5 3.4-3.4 3.4z",
    fill: "#DDCCA2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2 13.1h-1.9c-.7 0-1.2-.5-1.2-1.2v-.3c0-.7.5-1.2 1.2-1.2h1.9c.7 0 1.2.5 1.2 1.2v.3c0 .6-.5 1.2-1.2 1.2z",
    fill: "#243865",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#243865",
    fillRule: "nonzero",
    cx: 18.7,
    cy: 8.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#243865",
    fillRule: "nonzero",
    cx: 8.6,
    cy: 8.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 13l-.3 1.3c0 .1-.1.1-.2.1s-.1-.1-.1-.1l-.3-1.3c-.1-.3.1-.6.4-.6.3-.1.6.1.6.4-.1 0-.1.1-.1.2z",
    fill: "#243865",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4 15.8h1.1c1.2 0 2.2-1 2.2-2.2",
    stroke: "#243865",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D89868",
    fillRule: "nonzero",
    cx: 22.9,
    cy: 5.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3 5.7c.5.9-3.8-.1-2.7-.6 1-.6 2.2-.3 2.7.6z",
    fill: "#DDCCA2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D89868",
    fillRule: "nonzero",
    cx: 2.8,
    cy: 5.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4 5.6c-.5.9 3.8-.1 2.7-.6-1-.6-2.2-.3-2.7.6z",
    fill: "#DDCCA2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 3.9L12.5.6c-1.6.8-2.7 2.2-3.3 3.9v.1",
    fill: "#D89868",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6 4.8l-.7-3.3c-1.6.8-2.7 2.2-3.3 3.9v.1",
    fill: "#D89868",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#649EF7",
    fillRule: "nonzero",
    opacity: 0.2,
    d: "M39.8 32.8H41V34h-1.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#649EF7",
    fillRule: "nonzero",
    opacity: 0.2,
    cx: 40.5,
    cy: 35.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3 39.3v-.8",
    stroke: "#649EF7",
    opacity: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#649EF7",
    fillRule: "nonzero",
    cx: 17.4,
    cy: 36.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7 38.5h-2c-.5 0-1 .4-1 1 0 .5-.4 1-1 1h-2.2",
    stroke: "#DBE1EE",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 44.3h-6.4c-1.1 0-2-.9-2-2v-3.7c0-1.1.9-2 2-2H33c1.1 0 2 .9 2 2v3.7c0 1.1-.9 2-2 2z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B4784",
    fillRule: "nonzero",
    cx: 27.5,
    cy: 39.6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 27.5,
    cy: 39.6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#649EF7",
    fillRule: "nonzero",
    cx: 27.5,
    cy: 41.8,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#649EF7",
    fillRule: "nonzero",
    opacity: 0.2,
    d: "M30 38.9h1.2v1.2H30zM32 38.9h1.2v1.2H32zM32 40.9h1.2v1.2H32zM30 40.9h1.2v1.2H30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7 31.8v7.6c0 .6.5 1.1 1.1 1.1H24",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#DDCCA2",
    fillRule: "nonzero",
    d: "M34.291 41.649l2.829-2.828 2.828 2.828-2.828 2.828zM244.97 69.563l2.829-2.828 2.828 2.828-2.828 2.828z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#DDCCA2",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.8 0v5.6M197.7 2.8H192"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySequences);
export default __webpack_public_path__ + "static/media/EmptySequences.706db330c2f50f72ab2fe26002e688f0.svg";
export { ForwardRef as ReactComponent };